import React from 'react';
import Modal from 'components/Modal'

// components

export default function Delete(props) {

    return (
        <>
            <Modal show={props.show} handleClose={props.close} title={props.title}>
                <div className="modal-body gap-y-3">
                    <h4>آیا از حذف این کاربر مطمئن هستید؟</h4>
                </div>
                <div className="modal-footer flex justify-between">
                    <button className="btn btn-danger w-20" type="button" onClick={props.submite}>
                        حذف
                    </button>
                    <button type="button" onClick={props.close} className="btn btn-outline-secondary w-20 mr-1 text-white">
                        انصراف
                    </button>
                </div>
            </Modal>
        </>
    );
}
